import { useLayoutEffect, useState } from 'react';
import {
  DefaultAccountClient,
  type IdentityEnvironment,
} from '@atlassian/account-client';
import { useToken } from '../components/Flow/ConsentContextProvider';

const fedrampSuffix = '-fedm';
const rawEnv = process.env.ENV_TYPE ?? 'dev';
const isFedramp = rawEnv.endsWith(fedrampSuffix);
// If the env ends with "-fedm" then strip the suffix
const envType = isFedramp
  ? rawEnv.substring(0, rawEnv.length - fedrampSuffix.length)
  : rawEnv;

const accountClient = new DefaultAccountClient({
  identityEnvironment: envType as IdentityEnvironment,
  defaultContinueUrl: window.location.href,
  perimeter: isFedramp ? 'fedramp-moderate' : 'commercial',
});

// Copied from the @atlassian/account-client docs
// Will be undefined if still loading, null if logged out, or the user's profile otherwise.
export function useUser(accountClientOverride?: DefaultAccountClient) {
  const client = accountClientOverride ?? accountClient;
  const [user, setUser] = useState(client.currentUser);
  useLayoutEffect(() => client.addUserListener(setUser), []);
  if (user === null && process.env.APP_VERSION !== 'test') {
    console.warn('Not logged in, redirecting to login page');
    window.location.href = client.getLoginLink();
  }
  return user;
}

export function useSwitchAccountLink(prependIdDomainUrl?: boolean) {
  const { audience, redirectUrl } = useToken();
  const continueUrl = `https://${audience}${redirectUrl?.raw}`;
  if (prependIdDomainUrl ?? true) {
    return getAccountClient().getSwitchAccountLink({ continueUrl });
  }
  return continueUrl;
}

export const getAccountClient = () => accountClient;
